module.exports = __webpack_public_path__ + "img/btn_auto_spin_on.bfff701d.png";